"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Input_1 = __importDefault(require("./Input"));
function extractNumber(val, type) {
    if (type === 'number' && typeof val !== 'number') {
        return Number(val.replaceAll(/[^\d.-]/g, ''));
    }
    return val;
}
const EditableColumn = (0, react_1.forwardRef)(function EditableColumn(props, ref) {
    const { onSave = () => null, value, type = 'text', style, onEditStart = () => null, editStatus = false, validate = () => true, textOverFlowEllipses = false, ...InputProps } = props;
    const [enabled, enableEdit] = (0, react_1.useState)();
    const [isValid, setValid] = (0, react_1.useState)(true);
    const [val, setVal] = (0, react_1.useState)(extractNumber(value, type));
    (0, react_1.useEffect)(() => {
        enableEdit(editStatus);
    }, [editStatus]);
    (0, react_1.useImperativeHandle)(ref, () => ({
        startEdit: () => {
            enableEdit(true);
        },
        closeEdit: () => {
            enableEdit(false);
        },
    }));
    const mouseClickCallback = (0, react_1.useCallback)((e) => {
        if (!e.target.classList.contains('editable-column')) {
            enableEdit(false);
            window.removeEventListener('mousedown', mouseClickCallback);
        }
    }, []);
    function startEditHandler() {
        window.addEventListener('mousedown', mouseClickCallback);
        onEditStart(true);
        enableEdit(true);
    }
    function editHandler(event) {
        const valid = validate(val);
        setValid(valid);
        // when press Enter or Tab
        if (valid && ['Enter', 'Tab'].includes(event.key)) {
            onSave(event);
            enableEdit(false);
        }
        // close edit mode if press Enter, Tab or Escape
        if (['Escape'].includes(event.key)) {
            enableEdit(false);
            window.removeEventListener('mousedown', mouseClickCallback);
        }
    }
    function handleChange(e) {
        setVal(e.target.value);
    }
    return ((0, jsx_runtime_1.jsxs)("div", { style: {
            display: 'table',
            width: '100%',
            height: '100%',
            ...(textOverFlowEllipses
                ? { whiteSpace: 'nowrap', overflow: 'hidden', display: 'inline-flex' }
                : {}),
            ...style,
        }, className: "editable-column-input", onDoubleClick: startEditHandler, children: [!enabled && ((0, jsx_runtime_1.jsx)("span", { style: {
                    display: 'table-cell',
                    verticalAlign: 'middle',
                    width: '100%',
                    ...(textOverFlowEllipses
                        ? { textOverflow: 'ellipsis', overflow: 'hidden' }
                        : {}),
                }, children: value })), enabled && ((0, jsx_runtime_1.jsx)("div", { style: { display: 'table-cell', verticalAlign: 'middle' }, children: (0, jsx_runtime_1.jsx)(Input_1.default, { style: {
                        inputWrapper: {
                            ...(!isValid && { borderColor: 'red' }),
                            width: '100%',
                        },
                        input: {
                            padding: '5px',
                            width: '100%',
                            minWidth: '60px',
                        },
                    }, autoSelect: true, className: "editable-column", value: val, type: type, onChange: handleChange, onKeyUp: editHandler, onMouseDown: (e) => e.stopPropagation(), ...InputProps }) }))] }));
});
exports.default = EditableColumn;
